import { Button } from '@components/button';
import { IconTrash } from '@components/icons/trash';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { useDelete } from 'api/locations/hooks';
import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  locationId: number;
}>;

export const DeleteLocationModal = (props: Props) => {
  const { current, t } = useStore();
  const { showSuccess } = useToaster();
  const deleteLocation = useDelete({
    locationId: props.locationId,
    onSuccess: () => {
      current.loadInfo(); // To fetch the locations again for create/edit job
      showSuccess(t('modals.deletelocation.success'));
      props.closeModal();
    },
  });
  return (
    <Stack space={6}>
      <Text font="heading1" text={t('modals.deletelocation.header')} />
      <Text font="regular16" text={t('modals.deletelocation.text')} />
      <Stack orientation="horizontal" space={4} justify="flex-end">
        <Button
          variant="secondary"
          onClick={props.closeModal}
          text={t('common.forms.button.cancel')}
        />
        <Button
          isDisabled={deleteLocation.isLoading}
          onClick={() => deleteLocation.mutate()}
          variant="primary-red"
          iconLeft={<IconTrash />}
          text={t('modals.deletelocation.save')}
        />
      </Stack>
    </Stack>
  );
};
